import React, { Component } from "react"
import Recaptcha from "react-google-recaptcha"

import parse from "html-react-parser"
import { navigate } from "gatsby"

const RECAPTCHA_KEY = "6Lc_mi0iAAAAAPxvjkOBguy-Y9VKzHpmRV6HIGSi"

class Form extends Component {
  state = {
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  handleChange = (e) => {
    let { form } = this.state
    if (e.target.name === "type") {
      let current = form[e.target.name] || ""
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + " " + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(" " + e.target.value, "")
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleRecaptcha = (value) => {
    this.setState({ "g-recaptcha-response": value })
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    let sendTo = 'rory@whitefoxrealestate.com.au, marty@whitefoxrealestate.com.au, shura@whitefoxrealestate.com.au, taylor@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'perth') sendTo = 'perth@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'adelaide') sendTo = 'adelaide@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'brisbane') sendTo = 'brisbane@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'gc') sendTo = 'goldcoast@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'nz') sendTo = 'marty@whitefoxrealestate.com.au, rory@whitefoxrealestate.com.au, brittany@whitefoxrealestate.co.nz'

    const formData = new FormData(this.form.current)
    formData.append("form-name", this.form.current.getAttribute("name"))
    formData.append("sendTo", sendTo)
    const queryString = new URLSearchParams(formData).toString()

    // https://zapier.com/editor/216287034/published/216287035/sample 
    await fetch(
      "https://hooks.zapier.com/hooks/catch/2181815/3kccu43/?" + queryString
    )

    this.setState({ result: "success" })
  }

  render() {
    let props = {
      ref: this.form,
      name: "basic_form_block",
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === "success") {
      navigate("/thank-you")
      return (
        <div className="signup__nav">
          <p>
            Thanks for getting in contact with us.
            <br /> A member of our team will be in touch soon.
          </p>
        </div>
      )
    }

    return (
      <div className="signup__nav">

        <form {...props}>
          <input type="hidden" name="source" value={this.props.source ? this.props.source : 'basic_form_block'} />

          <input
            type="text"
            name="name"
            placeholder="Your Name*"
            onChange={this.handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email*"
            onChange={this.handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Contact Number*"
            onChange={this.handleChange}
            required
          />
          <textarea
            name="message"
            onChange={this.handleChange}
            placeholder="Leave a message"
          />
          <div className="recaptcha__wrapper">
            <Recaptcha
              ref="recaptcha"
              sitekey={RECAPTCHA_KEY}
              onChange={this.handleRecaptcha}
            />
          </div>
          <button className="contactbtn" type="submit">
            Submit 
          </button>
          {this.state.result !== "" && (
            <p
              className="paragraph"
              dangerouslySetInnerHTML={{ __html: this.state.msg }}
            />
          )}
        </form>
      </div>
    )
  }
}

class BasicFormBlock extends Component {
  render() {
    const { title, source } = this.props

    return (
      <section className="basic-form-block" data-color="#FFFFFF" id="contact">
        <div className="basic-form-block__inner container">
          {title && <h3 dangerouslySetInnerHTML={{ __html: title }} />}
          <div className="basic-form-block__form">
            <Form source={source} />
          </div>
        </div>
      </section>
    )
  }
}

export default BasicFormBlock
